const changeDate = (date, text = 'Ввод в эксплуатацию') => {
  const [year, month, day] = date?.split('-') || [];

  if (text === 'Ввод в эксплуатацию') {
    if (month >= '01' && month <= '03') return `${text} I кв. ${year}`;
    if (month >= '04' && month <= '06') return `${text} II кв. ${year}`;
    if (month >= '07' && month <= '09') return `${text} III кв. ${year}`;
    if (month >= '10' && month <= '12') return `${text} IV кв. ${year}`;
  }

  return `${text} ${day}.${month}.${year}`;
};

export default changeDate;
